'use client';

import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _ArrowIosLeft, _AlertTriangle, _PrimitiveDropdownLoa, _ArrowIosRight;
var _excluded = ["categories", "onCategorySelect", "loading", "onSelectionChange", "defaultValues", "trackByCategory", "renderSubItem", "multiselect"];
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import React, { useCallback, useEffect, useState } from 'react';
import AlertTriangle from '@crehana/compass.icons.outline/AlertTriangle';
import ArrowIosLeft from '@crehana/compass.icons.outline/ArrowIosLeft';
import ArrowIosRight from '@crehana/compass.icons.outline/ArrowIosRight';
import { useTranslation } from '@crehana/i18n';
import { Button } from "../../../Button";
import { EmptyState } from "../../../EmptyState";
import { CommandItem } from "../../../_shadcn-native-components/command";
import { Checkbox } from "../../../Checkbox";
import { cn } from "../../../utils";
import { useDropdownContext } from "../../context";
import { DropdownBaseList } from "../../DropdownBaseList";
import locales from "../../i18n";
import { PrimitiveDropdownLoading } from "../../primitive-dropdown";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function AsyncLeveledDropdown(_ref) {
  var categories = _ref.categories,
    onCategorySelect = _ref.onCategorySelect,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    onSelectionChange = _ref.onSelectionChange,
    _ref$defaultValues = _ref.defaultValues,
    defaultValues = _ref$defaultValues === void 0 ? [] : _ref$defaultValues,
    _ref$trackByCategory = _ref.trackByCategory,
    trackByCategory = _ref$trackByCategory === void 0 ? false : _ref$trackByCategory,
    renderSubItem = _ref.renderSubItem,
    _ref$multiselect = _ref.multiselect,
    multiselect = _ref$multiselect === void 0 ? true : _ref$multiselect,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    languageCode = _useTranslation.languageCode;
  var dropdownContext = useDropdownContext();
  var t = locales[languageCode];
  if (!dropdownContext) {
    console.error('AsyncLeveledDropdown: Missing DropdownProvider context. Please wrap the component with DropdownProvider or @crehana/compass.ui/v2/Dropdown');
    return null;
  }
  var values = dropdownContext.values,
    setItems = dropdownContext.setItems,
    setValues = dropdownContext.setValues;
  // biome-ignore lint/correctness/useHookAtTopLevel: conditional hook usage is intentional here
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedCategory = _useState2[0],
    setSelectedCategory = _useState2[1];
  // biome-ignore lint/correctness/useHookAtTopLevel: conditional hook usage is intentional here
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    subItems = _useState4[0],
    setSubItems = _useState4[1];
  // biome-ignore lint/correctness/useHookAtTopLevel: conditional hook usage is intentional here
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoadingItems = _useState6[0],
    setIsLoadingItems = _useState6[1];
  // biome-ignore lint/correctness/useHookAtTopLevel: conditional hook usage is intentional here
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isError = _useState8[0],
    setIsError = _useState8[1];

  // biome-ignore lint/correctness/useHookAtTopLevel: conditional hook usage is intentional here
  useEffect(function () {
    setItems(categories.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        type: 'checkbox'
      });
    }));
  }, [categories, setItems]);

  // biome-ignore lint/correctness/useHookAtTopLevel: conditional hook usage is intentional here
  useEffect(function () {
    if (defaultValues.length > 0) {
      setValues(defaultValues);
    }
  }, [defaultValues, setValues]);

  // biome-ignore lint/correctness/useHookAtTopLevel: conditional hook usage is intentional here
  var fetchCategoryItems = useCallback(
  /*#__PURE__*/
  // biome-ignore lint/suspicious/useAwait: async test without await
  function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(categoryId) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setIsLoadingItems(true);
            setIsError(false);

            // Non-blocking async operation
            onCategorySelect(categoryId).then(function (items) {
              setSubItems(items);
              setItems(items);
            })["catch"](function (error) {
              console.error('Error loading category items:', error);
              setSubItems([]);
              setIsError(true);
            })["finally"](function () {
              setIsLoadingItems(false);
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [onCategorySelect, setItems]);

  // biome-ignore lint/correctness/useHookAtTopLevel: conditional hook usage is intentional here
  var handleCategorySelect = useCallback(function (categoryId) {
    setSelectedCategory(categoryId);
    fetchCategoryItems(categoryId);
  }, [fetchCategoryItems]);

  // biome-ignore lint/correctness/useHookAtTopLevel: conditional hook usage is intentional here
  var handleRetry = useCallback(function () {
    if (selectedCategory) {
      fetchCategoryItems(selectedCategory);
    }
  }, [selectedCategory, fetchCategoryItems]);

  // biome-ignore lint/correctness/useHookAtTopLevel: conditional hook usage is intentional here
  var handleSelection = useCallback(function (value, state) {
    var categoryPrefix = trackByCategory ? "".concat(selectedCategory, ".") : '';
    var processedValue = "".concat(categoryPrefix).concat(value);
    var newSelection = multiselect ? state ? [].concat(_toConsumableArray(values), [processedValue]) : values === null || values === void 0 ? void 0 : values.filter(function (item) {
      return item !== processedValue;
    }) : [processedValue];
    setValues(newSelection);
    if (onSelectionChange) {
      if (trackByCategory) {
        var categorizedValues = newSelection.reduce(function (acc, curr) {
          var _String$split = String(curr).split('.'),
            _String$split2 = _slicedToArray(_String$split, 2),
            category = _String$split2[0],
            value = _String$split2[1];
          // biome-ignore lint/style/useBlockStatements: single-line early return
          if (!acc[category]) acc[category] = [];
          acc[category].push(value);
          return acc;
        }, {});
        onSelectionChange(categorizedValues);
      } else {
        onSelectionChange(newSelection);
      }
    }
  }, [values, setValues, onSelectionChange, selectedCategory, trackByCategory, multiselect]);

  // biome-ignore lint/correctness/useHookAtTopLevel: conditional hook usage is intentional here
  var handleClearCategory = useCallback(function () {
    if (subItems.length > 0) {
      var categoryPrefix = trackByCategory ? "".concat(selectedCategory, ".") : '';
      var newSelection = values === null || values === void 0 ? void 0 : values.filter(function (item) {
        return !subItems.map(function (subcategory) {
          return "".concat(categoryPrefix).concat(subcategory.value);
        }).includes(String(item));
      });
      setValues(newSelection);
      if (onSelectionChange) {
        if (trackByCategory) {
          var categorizedValues = newSelection.reduce(function (acc, curr) {
            var _String$split3 = String(curr).split('.'),
              _String$split4 = _slicedToArray(_String$split3, 2),
              category = _String$split4[0],
              value = _String$split4[1];
            // biome-ignore lint/style/useBlockStatements: single-line early return
            if (!acc[category]) acc[category] = [];
            acc[category].push(value);
            return acc;
          }, {});
          onSelectionChange(categorizedValues);
        } else {
          onSelectionChange(newSelection);
        }
      }
    }
  }, [subItems, values, setValues, onSelectionChange, selectedCategory, trackByCategory]);
  var selectedValues = values.filter(function (value) {
    if (trackByCategory) {
      return String(value).startsWith("".concat(selectedCategory, "."));
    }
    return subItems.some(function (item) {
      return item.value === value;
    });
  });

  // biome-ignore lint/correctness/useHookAtTopLevel: conditional hook usage is intentional here
  var defaultRenderSubItem = useCallback(function (_ref3) {
    var item = _ref3.item,
      isSelected = _ref3.isSelected,
      _onSelect = _ref3.onSelect;
    return /*#__PURE__*/_jsxs(CommandItem, {
      className: "tw-justify-start",
      value: item.value.toString(),
      removeCheck: true,
      onSelect: function onSelect() {
        return _onSelect(item.value, !isSelected);
      },
      children: [multiselect && /*#__PURE__*/_jsx(Checkbox, {
        checked: isSelected
      }), item.label]
    }, item.value);
  }, [multiselect]);
  return /*#__PURE__*/_jsx(DropdownBaseList, {
    className: props.className,
    children: selectedCategory ? /*#__PURE__*/_jsxs("div", {
      className: "tw-relative tw-flex tw-flex-col",
      children: [/*#__PURE__*/_jsxs("button", {
        onClick: function onClick() {
          setSelectedCategory(undefined);
          setSubItems([]);
          setIsLoadingItems(false);
          setIsError(false);
        },
        className: cn('tw-flex tw-items-center tw-gap-0.4 tw-sticky tw-top-0 tw-z-2', 'tw-bg-neutral-light-100 dark:tw-bg-neutral-dark-700', 'tw-w-full tw-text-left tw-py-0.8 tw-px-2.4 tw-font-caption tw-text-primary-light-500 dark:tw-text-secondary-light-500', 'hover:tw-text-primary-light-400 hover:dark:tw-text-secondary-light-400 hover:tw-bg-neutral-light-300 dark:hover:tw-bg-neutral-dark-600'),
        children: [_ArrowIosLeft || (_ArrowIosLeft = /*#__PURE__*/_jsx(ArrowIosLeft, {
          size: 20,
          className: "tw-text-primary-light-500 dark:tw-text-secondary-light-500"
        })), t.DROPDOWN_OPTIONS_BACK_BUTTON]
      }), isError && /*#__PURE__*/_jsx(EmptyState, {
        className: "tw-h-full tw-w-full !tw-p-0.8 !tw-m-0",
        icon: _AlertTriangle || (_AlertTriangle = /*#__PURE__*/_jsx(AlertTriangle, {
          size: 20,
          className: "tw-text-neutral-light-600"
        })),
        title: t.DROPDOWN_ERROR_TITLE,
        description: t.DROPDOWN_ERROR_DESCRIPTION,
        primaryAction: /*#__PURE__*/_jsx(Button, {
          type: "button",
          variant: "delete",
          size: "xs",
          onClick: handleRetry,
          children: t.DROPDOWN_ERROR_RETRY
        }),
        small: true
      }), isLoadingItems ? _PrimitiveDropdownLoa || (_PrimitiveDropdownLoa = /*#__PURE__*/_jsx(PrimitiveDropdownLoading, {
        className: "tw-h-20",
        loading: true
      })) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [subItems.map(function (item) {
          var categoryPrefix = trackByCategory ? "".concat(selectedCategory, ".") : '';
          var processedValue = "".concat(categoryPrefix).concat(item.value);
          var isSelected = values.includes(processedValue);
          return /*#__PURE__*/_jsx(React.Fragment, {
            children: (renderSubItem || defaultRenderSubItem)({
              item: item,
              isSelected: isSelected,
              onSelect: function onSelect(value, state) {
                return handleSelection(value, state);
              }
            })
          }, item.value);
        }), multiselect && subItems.length > 0 &&
        /*#__PURE__*/
        // biome-ignore lint/a11y/useButtonType: button type handled elsewhere
        _jsx("button", {
          onClick: handleClearCategory,
          className: cn('tw-w-full tw-sticky tw-bottom-0 tw-text-left tw-py-1.2 tw-px-2.4 tw-font-caption tw-text-primary-light-500 dark:tw-text-secondary-light-500', 'tw-bg-neutral-light-100 dark:tw-bg-neutral-dark-700', 'hover:tw-text-primary-light-400 hover:dark:tw-text-secondary-light-400 hover:tw-bg-neutral-light-300 dark:hover:tw-bg-neutral-dark-600'),
          children: t.DROPDOWN_OPTIONS_ERASE_ALL
        })]
      })]
    }) : categories.map(function (item) {
      return /*#__PURE__*/_jsxs(CommandItem, {
        value: item.value.toString(),
        removeCheck: true,
        onSelect: function onSelect() {
          return handleCategorySelect(item.value);
        },
        children: [/*#__PURE__*/_jsxs("div", {
          className: "tw-flex tw-items-center tw-gap-0.8",
          children: [item.label, selectedValues.length > 0 && /*#__PURE__*/_jsx("span", {
            className: "tw-rounded tw-flex tw-items-center tw-justify-center tw-w-2 tw-h-2 tw-font-body5 tw-bg-primary-light-500 tw-text-neutral-light-100",
            children: selectedValues.length
          })]
        }), _ArrowIosRight || (_ArrowIosRight = /*#__PURE__*/_jsx(ArrowIosRight, {
          size: 24,
          className: "tw-text-primary-light-500 dark:tw-text-secondary-light-500"
        }))]
      }, item.value);
    })
  });
}